<script lang="ts" setup>
import { RoutesEnum } from '~/enums'
import { FOOTER_MENUS } from '~/resources/menus'

const { BRAND_NAME, COPYRIGHT_YEAR } = useRuntimeConfig().public
const expandedItemIndex = ref<number | null>(null)
const router = useRouter()

const handleToggle = (index: number) => {
  expandedItemIndex.value = expandedItemIndex.value === index ? null : index
}

watch(
  () => router.currentRoute.value,
  () => {
    expandedItemIndex.value = null
  },
)
</script>

<template>
  <div class="mobile-footer">
    <div class="mobile-footer__divider" />
    <div class="mobile-footer__container">
      <div class="mobile-footer__intro">
        <div class="mobile-footer__intro__content">
          <img
            class="mobile-header__logo"
            src="/images/logo/logo.svg"
            alt="logo"
            width="80"
            height="30"
          />
          <div class="mobile-footer__intro__content__text">
            {{ BRAND_NAME }} là nhà cái uy tín hàng đầu Châu Âu, cung cấp các
            sản phẩm cá cược
            <NuxtLink
              :to="RoutesEnum.About"
              class="mobile-footer__intro__content__text--more"
              >Xem thêm</NuxtLink
            >
          </div>
        </div>
      </div>

      <div class="mobile-footer__collapse">
        <MobileFooterItemCollapse
          v-for="(item, index) in FOOTER_MENUS(BRAND_NAME)"
          :key="index"
          :item="item"
          :large-grid="index === 0"
          :is-expanded="expandedItemIndex === index"
          @toggle="handleToggle(index)"
        />
      </div>

      <MobileFooterItemPayments class="mt-4" />
      <div class="mobile-footer__backer">
        <img
          src="/images/footer/logo_right.webp"
          alt="backer"
          height="48"
          width="189"
          loading="lazy"
        />
        <div>©{{ COPYRIGHT_YEAR }} {{ BRAND_NAME }}. All rights reserved</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/mobile/footer/index.scss';
</style>
